import {ICountyModel} from '../models/ICountyModel';
import * as CountyActions from '../actions/CountyActions';
import {createFeatureSelector, createReducer, createSelector, on} from '@ngrx/store';

const initialState: Array<ICountyModel> = [{Id: 153, Name: 'Polk'}];

export const reducer = createReducer(
  initialState,
  on(CountyActions.CountiesReceivedAction, (state, {counties}) => ([
      ...state, ...counties
    ])
  )
);

export const featureSelector = createFeatureSelector<Array<ICountyModel>>('counties');
export const getCounties = createSelector(
  featureSelector,
  state => state
);
